import { composeInitialState } from '@opengov/compose-app';

import { IToastProps } from '../../classic/components/Toast';
import { contextMenuActions } from '../contextMenus';
import { modalActions } from '../modals';
import { composeStateMachine } from '../module';

const toastInitialState: IToastProps = {
  type: 'FAILURE',
  headerText: 'DEFAULT MESSAGE',
  bodyText: 'DEFAULT MESSAGE',
  dataTest: `toast-default`
};

const capitalToastInitialState = {
  title: '',
  body: '',
  variant: 'failure' as any,
  dataTest: `toast-default`,
  onClose: () => {}
};

export const viewInitialState = composeInitialState({
  isModalOpen: false,
  isContextMenuOpen: false,
  isToastOpen: false,
  isCapitalToastOpen: false,
  contextMenuTargetClicked: false,
  toast: toastInitialState,
  capitalToast: capitalToastInitialState
});

export const viewState = composeStateMachine(
  'VIEW',
  viewInitialState,
  (compose) => ({
    documentClicked: compose.payloadlessAction((state) =>
      // This ensure that's the context menu stays open if the element clicked
      // is a context menu target. If you have any questions, come see me.
      // - Chris Loeper
      state
        .set('contextMenuTargetClicked', false)
        .set('isContextMenuOpen', state.contextMenuTargetClicked ? true : false)
    ),

    toggleContextMenu: compose.payloadlessAction((state) => state.set('isContextMenuOpen', !state.isContextMenuOpen)),

    toggleModal: compose.payloadlessAction((state) => state.set('isModalOpen', !state.isModalOpen)),

    showToast: compose.action((state, payload: IToastProps) => state.set('toast', payload).set('isToastOpen', true)),
    showCapitalToast: compose.action((state, payload) =>
      state.set('capitalToast', payload).set('isCapitalToastOpen', true)
    ),

    hideToast: compose.payloadlessAction((state) => state.set('isToastOpen', false)),
    hideCapitalToast: compose.payloadlessAction((state) => state.set('isCapitalToastOpen', false))
  }),
  (compose) => [
    compose.payloadlessActionReducer(modalActions.resetModalState, (state) => state.set('isModalOpen', false)),
    compose.payloadlessActionReducer(modalActions.setModalComponentType, (state) => state.set('isModalOpen', true)),
    compose.payloadlessActionReducer(contextMenuActions.resetContextMenuState, (state) =>
      state.set('isContextMenuOpen', false).set('contextMenuTargetClicked', false)
    ),
    compose.payloadlessActionReducer(contextMenuActions.setContextMenuData, (state) =>
      state.set('isContextMenuOpen', true).set('contextMenuTargetClicked', true)
    )
  ]
);

export const {
  actions: viewActions,
  actionCreators: viewActionCreators,
  reducer: viewReducer,
  selector: viewSelector
} = viewState;
